import axios from 'axios';
import { toast } from 'react-toastify';

import instanceAxios from '../axios/instanceAxios';
import catchError from './catchError';

/**
 * The HTTP POST method sends data to the server.
 * The type of the body of the request is indicated by the Content-Type header.
 *
 * @param {string} endpoint
 * @example
 * "/example/endpoint"
 * @param {object} body - { productId: 123456, siteCode: "JD" }
 * @param {string} errorMessageHeader - Message that proceeds the error message.
 * Usually to provide context on what exactly has errored.
 * @example
 * "Get Categories"
 * @param {string?} successMessage - "Product has successfully been updated with new value"
 * @param {object?} headers
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postRequest(endpoint, body, errorMessageHeader, successMessage, headers) {
  return new Promise((resolve, reject) => {
    instanceAxios()
      .post(endpoint, body, headers)
      .then((response) => {
        if (successMessage?.length > 0) toast.success(successMessage);
        resolve(response);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          catchError(error, errorMessageHeader);
          reject(error);
        }
        // console.error(error);
      });
  });
}

export default postRequest;
